import { Button, ButtonGroup, Grid } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import AlertDialog from "../../../components/alert-dialog/AlertDialog";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import { PagePlaceholder } from "../../../components/page-placeholder/PagePlaceholder";
import SimpleTable from "../../../components/table/Table";
import { getIcon } from "../../../icon/icon";
import styles from "./ListCampaignsPage.module.scss";
import { getCampaigns } from "../../../state/actions/CampaignActions";
import ScrollableTabs from "../../../components/tabs/Tabs";
import { ModelType, modelTypeToString, modelTypeToIndex } from "../../../state/constants/ModelType";
import PageContainer from "../../../components/page-container/PageContainer";
import Search from "../../../components/search/Search";
import { withTranslation } from "react-i18next";


class ListCampaignsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      campaigns: props.campaigns,
      selectedCampaignIds: [],
      originalData: [],
      searchedData: [],
      currentModelType: props.currentModelType,
      deleteAlertShowing: false
    };
  }

  componentDidMount() {
    this.setupData(this.props.currentModelType || ModelType.CUSTOMERS);
  }

  componentDidUpdate() {
    if (
      JSON.stringify(this.state.campaigns) !==
      JSON.stringify(this.props.campaigns)
    ) {
      const data = this.createData(this.props.campaigns);

      this.setState({
        campaigns: this.props.campaigns,
        originalData: data,
        searchedData: data,
        currentModelType: this.props.currentModelType
      });
    }
  }

  setupData(modelType) {
    this.setState({ loading: true, currentModelType: modelType });
    this.props.getCampaigns(() => {
      const data = this.createData(this.props.campaigns);

      this.setState({
        loading: false,
        originalData: data,
        searchedData: data,
        campaigns: this.props.campaigns,
        currentModelType: this.props.currentModelType
      });
    });
  }

  createData(campaigns) {
    const campaignKeys = Object.keys(campaigns);

    return campaignKeys.map(campaignKey => {
      const campaign = campaigns[campaignKey];

      return {
        campaignId: campaignKey,
        name: campaign.DisplayName
      };
    });
  }

  createHeaders() {
    return [
      {
        id: "name",
        clickable: true,
        action: { path: "/campaigns/{id}", identifier: "campaignId" },
        align: "left",
        label: this.props.t('campaign.name')
      },
      {
        id: "campaignId",
        clickable: false,
        align: "left",
        label: this.props.t('campaign.id')
      }
    ];
  }

  createCells(headers) {
    let cells = [];

    headers.forEach(header => {
      let cell = {};

      cell.id = header.id;

      if (header.hasOwnProperty("action")) {
        cell.handleClick = (event, row) => {
          let path = header.action.path.replace(
            "{id}",
            row[header.action.identifier]
          );
          this.props.history.push(path);
        };
      }

      cell.align = header.align;
      cell.clickable = header.clickable;

      cells.push(cell);
    });

    return cells;
  }

  onTabChange(newValue) {
    this.setupData(newValue === modelTypeToIndex(ModelType.CUSTOMERS) ? ModelType.CUSTOMERS : ModelType.PRODUCTS);
  }

  renderData() {
    const headers = this.createHeaders();
    const cells = this.createCells(headers);

    const data = this.state.searchedData.length === 0 ?
      <PagePlaceholder
        image={getIcon("licencse.svg")}
        text={this.props.t('campaign.none-found')}
      /> :
      <SimpleTable
        handleSelection={selectedIds => {
          this.setState({ selectedCampaignIds: selectedIds });
        }}
        isSelectable={false}
        onClick={() => { }}
        dataId={"campaignId"}
        cells={cells}
        headers={headers}
        rows={this.state.searchedData}
      />


    return data

  }

  alertDialog() {
    return (
      <AlertDialog
        title={this.props.t('common.remove-question')}
        description={this.props.t('common.remove-description')}
        options={[
          {
            label: this.props.t('common.cancel'),
            action: () => this.setState({ deleteAlertShowing: false })
          },
          { label: this.props.t('common.delete'), action: () => this.deleteSelection() }
        ]}
        isOpen={this.state.deleteAlertShowing}
      />
    );
  }

  deleteSelection() {
    // this.props.removeCategories(this.state.selectedCampaignIds, () => {
    //   this.setState({ selectedCampaignIds: [], deleteAlertShowing: false });
    // });
  }

  render() {

    return (
      <div>
        {this.alertDialog()}

        <HeaderBlock
          title={this.props.t('campaign.campaigns')}
          right={
            <Grid container spacing={2} alignItems="center" justify="flex-end">
              <Grid item>
                <Search
                  searchField={"name"}
                  secondaryFields={["campaignId"]}
                  returnSearchMatches={data => {
                    this.setState({ searchedData: data });
                  }}
                  data={this.state.originalData}
                  searchTitle={this.props.t('campaign.search')}
                />
              </Grid>
              <Grid item>

                <ButtonGroup classes={{ root: styles.buttonGroup }}>
                  <Button
                    onClick={() => { this.props.history.push("campaigns/new"); }}
                    variant="outlined"
                    color="secondary"
                  >
                    {this.props.t('campaign.new')}
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          }
        />
        <PageContainer hasFooter>
          {this.state.loading ? <Loading /> : this.renderData()}
        </PageContainer>
      </div>
    );
  }
}

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { campaigns, currentModelType } = state.CampaignReducer;
  return { campaigns, currentModelType };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getCampaigns
    },
    dispatch
  );

const hoc = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ListCampaignsPage))
);

// EXPORT COMPONENT

export { hoc as ListCampaignsPage };

